export const GET_SALESPERSONS_DATA = 'GET_SALESPERSONS_DATA'
export const SALES_REPORT_LOADING = 'SALES_REPORT_LOADING'
